import { createContext, useContext, useEffect, useState } from "react";

interface ImageViewerSplashContextProps {
    imgUrl : string;
    setImgUrl: Function;   
}

const ImageViewerSplashContext = createContext<ImageViewerSplashContextProps>({} as ImageViewerSplashContextProps);

export const useImageViewerSplashContext = () => {
  const context = useContext(ImageViewerSplashContext);
  if (context === undefined) {
    throw new Error("CustomContext must be used within a CustomContextProvider");
  }
  return context;
};

export const ImageViewerSplashContextProvider: React.FC = ({ children }) => {
    const [imgUrl, setImgUrl] = useState<string | undefined>(undefined);

    return (
        <ImageViewerSplashContext.Provider value={{imgUrl, setImgUrl}}>
            {children}
        </ImageViewerSplashContext.Provider>
    );
};

export default ImageViewerSplashContext;